<template>
    <div class="mt-4 pt-4">
        <div class="mt-4">
            <div class="row">
                <div class="col-12">
                    <div class="search-org">
                        <i class="nc-icon nc-zoom-split floating-search"></i>
                        <input type="search" class="form-control search-txt" placeholder="Search Organisation" v-model="search" />
                    </div>
                </div>
                <div class="container mt-4" v-if="is_admin">
                    <div class="row">
                        <div class="col-md-3 col-6 mb-3" v-for="c in org" :key="c.id">
                            <div class="card bg-light">
                                <div class="cover">
                                    <a href="javascript:void(0)" v-on:click="selectOrg(c)">
                                        <img v-if="c.picture != undefined" :src="'data:image/png;base64, ' + c.picture" class="card-img-top">
                                        <img v-else src="img/org-default.jpg" class="card-img-top" />
                                    </a>
                                </div>
                                <div class="card-body">
                                    <h4 class="card-title">
                                        <router-link :to="'/' + c.id + '/dashboard'">
                                            {{ c.name }}
                                        </router-link>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container" v-else>
                    <div class="row">
                        <div class="col-4" v-for="c in org" :key="c.organisation.id">
                            <div class="card">
                                <div class="cover">
                                    <router-link :to="'/' + c.organisation.id + '/dashboard'">
                                        <img v-if="c.organisation.picture != undefined" :src="'data:image/png;base64, ' + c.organisation.picture" class="">

                                        <img v-else src="img/org-default.jpg" />
                                    </router-link>
                                    <div class="action">
                                        <a class="text-light" :href="auth_ui + 'organisations/' + c.organisation.id + '/settings'" target="_blank" rel="noopener noreferrer">
                                            <i class="fa fa-pencil"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <h4 class="card-title">
                                        <router-link :to="'/' + c.organisation.id + '/dashboard'">
                                            {{ c.organisation.name }}
                                        </router-link>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex';
    export default {
        data() {
            return {
                org: [],
                is_admin: false,
                auth_ui: this.$auth_ui,
                search: ''
            }
        },
        computed: {
            ...mapGetters('auth', [
                'isSuperAdmin',
                'isPentester'
            ]),
            ...mapState('auth', [
                'user'
            ])
        },
        mounted() {
            this.init("");
        },
        watch: {
            search: function(txt) {
                this.init(txt);
            }
        },
        methods: {
            init(txt) {
                const me = this;

                if (!this.$store.state.auth.accessToken) {
                    window.location.href = me.$auth_ui + 'login/?redirect_url=' + encodeURIComponent(me.$ui + 'verify');
                    return;
                }

                if (this.isSuperAdmin || this.isPentester) {
                    me.is_admin = true;
                    this.$axios.get(this.$server + 'organisation?search=' + txt)
                    .then(res => {
                        me.org = res.data.organisations;
                    });

                } else {
                    this.$axios.get(this.$auth + 'orgadmin/organisations/users/' + this.user.user_id)
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            if (r.organisations.length == 1) {
                                me.$router.push({ path: "/" + r.organisations[0].organisation.id + "/dashboard" });
                            }
                            me.org = r.organisations;
                        }
                    });
                }
            },
            setAltImg(event) {
                event.target.src = "img/org-default.jpg"
            },
            selectOrg(org) {
                // TODO: This should be moved to a Vuex action
                localStorage.setItem("organisation", JSON.stringify(org));
                this.$router.push({path: '/' + org.id + '/dashboard'});
                setTimeout(()=>{
                    document.getElementById("reloadSidebar").click();
                }, 100);
            }
        }
    }
</script>